import { createTheme, responsiveFontSizes } from "@mui/material/styles";

/**
 * The project's theme is here.
 * Can also modify all the MUI components.
 */
export const createAppTheme = (mode, isMobile) => {
    let baseTheme = createTheme({
        palette: {
            mode, // Light or dark mode.
            primary: {
                main: "#fec01b"
            },
            text: {
                disabled: mode === "light" ? "rgba(0, 0, 0, 0.55)" : "rgba(255, 255, 255, 0.75)" // Increase opacity.
            }
        },
        typography: {
            fontFamily: `"Space Grotesk", "Poppins", "Libre Bodoni", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif`,
            fontSize: isMobile ? 11 : 14
        },
        tablerow: {
            fontSize: isMobile ? 6 : 13
        },
        input: {
            fontSize: isMobile ? 8 : 13
        },
        components: {
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        minWidth: 30
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        marginTop: 1,
                        marginBottom: 1
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: "5px 2px"
                        // fontSize: 10,
                    }
                }
            }
        }
    });

    // After creating the baseTheme, we can use varibles like palette.primary.main.
    const dynamicTheme = createTheme(baseTheme, {
        components: {
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        backgroundColor: baseTheme.palette.primary.main
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: mode === "light" ? "#ffffff" : "#121212"
                    }
                }
            }
        }
    });

    return responsiveFontSizes(dynamicTheme);
};
